import { FeatureFlag } from '@/enums/feature-flag';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useFeatureFlagsReady } from '@/hooks/use-feature-flags-ready';

export function useMcpTesterVisible() {
  const isReady = useFeatureFlagsReady();
  const hasMcpTester = useFeatureFlag(FeatureFlag.MCP_SERVER_TESTER);

  // LOCAL-ONLY OVERRIDE - DO NOT COMMIT. Forces the page visible so the UI can
  // be reviewed before the mcp_server_tester gate exists in Statsig.
  // Real behaviour is: return isReady && hasMcpTester;
  void isReady;
  void hasMcpTester;

  return true;
}
